import { graphql, readInlineData } from "react-relay";

import { checkIsPostiesArticle } from "~/components/article/article-render/posties/helpers";
import { checkIsPostiesPage } from "~/components/pages/posties-pages/helpers";
import type { helpersAppBarVariantBase$key } from "~/queries/__generated__/helpersAppBarVariantBase.graphql";

export type Application = "scmp" | "posties";

export const getApplication = (reference: helpersAppBarVariantBase$key): Application => {
  const content = readInlineData(
    graphql`
      fragment helpersApplicationBase on Base @inline {
        ...helpersCheckIsPostiesArticle
        ...helpersCheckIsPostiesPage
      }
    `,
    reference,
  );

  if (checkIsPostiesArticle(content) || checkIsPostiesPage(content)) return "posties";

  return "scmp";
};
